import Game from "@/legacy/views/Game";
import Gamelist from "@/legacy/views/Gamelist";
import Games from "@/legacy/views/Games";
import Home from "@/legacy/views/Home";
import Hosting from "@/legacy/views/Hosting";
import Map from "@/legacy/views/Map";
import Player from "@/legacy/views/Player";
import Upload from "@/legacy/views/Upload";
import Vue from "vue";
import Router from "vue-router";

import { router as rv2 } from "@/router";

import {
  delegate,
  navigate,
  redirect,
  resolve,
  scrollBehavior,
  setScroll,
} from "@/legacy/lib/routerUtils";

Vue.use(Router);

/** **/

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior,

  routes: rv2.options.routes.concat([
    {
      path: "/docs/:page?",
      name: "Documentation",
      component: () => import("@/legacy/views/Documentation"),
    },
    {
      path: "/discord",
      name: "Discord",
      beforeEnter() {
        window.location = "https://discord.gg/N3VGkUM";
      },
    },

    {
      path: "/discord-bot-invite",
      beforeEnter() {
        window.location =
          "https://discordapp.com/api/oauth2/authorize?client_id=615784551184334859&permissions=519233&scope=bot";
      },
    },

    {
      path: "/auto-uploader",
      name: "autoUploader",
      beforeEnter() {
        window.location = "/assets/WC3Stats Auto Uploader Setup 1.6.3.exe";
      },
    },

    {
      path: "/discord",
      name: "discord",
      beforeEnter() {
        window.location = "https://discord.gg/N3VGkUM";
      },
    },

    {
      path: "/ba",
      beforeEnter() {
        window.location = "/broken-alliances/leaderboard";
      },
    },

    {
      path: "/ba/discord",
      beforeEnter() {
        window.location = "https://discord.gg/My8acN4";
      },
    },

    {
      path: "/ba/clans",
      beforeEnter() {
        window.location = "/broken-alliances/clans";
      },
    },

    {
      path: "/broken-alliances",
      beforeEnter() {
        window.location = "/broken-alliances/leaderboard";
      },
    },

    /** **/

    {
      path: "/",
      component: Home,

      meta: {
        activeTab: "home",
      },
    },

    {
      path: "/upload",
      component: Upload,
      name: "upload",

      meta: {
        activeTab: "upload",
      },
    },

    {
      path: "/games",
      component: Games,
      name: "games",

      meta: {
        activeTab: "games",
      },
    },

    {
      path: "/gamelist",
      component: Gamelist,
      name: "gamelist",

      meta: {
        activeTab: "gamelist",
      },
    },

    {
      path: "/hosting-stats",
      component: Hosting,
      name: "hosting",

      meta: {
        activeTab: "gamelist",
      },
    },

    {
      path: "/games/:id/:tab?",
      component: Game,
      name: "gameProfile",

      meta: {
        activeTab: "games",
      },
    },

    // {
    //   path: '/players',
    //   component: Players,

    //   meta: {
    //       activeTab: 'players'
    //   }
    // },

    {
      path: "/players/:name/:tab?",
      component: Player,
      name: "playerProfile",

      meta: {},
    },

    // {
    //   path: '/broken-alliances/clans',
    //   component: Clans,
    //   name: 'Broken Alliances Clans',

    //   meta: {
    //     activeTab: 'maps'
    //   }
    // },

    // {
    //   path: '/broken-alliances/leaderboard',
    //   component: LeaderboardV2,
    //   name: 'Broken Alliances Leaderboard',

    //   meta: {
    //     activeTab: 'maps'
    //   }
    // },

    {
      path: "/broken-alliances/:tab?",
      component: Map,
      name: "Broken Alliances",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/warcraft-royale/:tab?",
      component: Map,
      name: "Warcraft Royale",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/weed-vs-greed/:tab?",
      component: Map,
      name: "Weed Vs Greed",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/castle-fight/:tab?",
      component: Map,
      name: "Castle Fight",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/pyro-td/:tab?",
      component: Map,
      name: "Pyro TD",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/hero-line-wars/:tab?",
      component: Map,
      name: "HLW",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/kings-and-knights/:tab?",
      component: Map,
      name: "Kings And Knights Alpha",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/mazing-contest/:tab?",
      component: Map,
      name: "Mazing Contest",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/risk-reforged/:tab?",
      component: Map,
      name: "Risk Reforged",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/risk-europe/:tab?",
      component: Map,
      name: "Risk Europe",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/dota/:tab?",
      component: Map,
      name: "DotA",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/legion-td/:tab?",
      component: Map,
      name: "Legion TD",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/green-solo-td/:tab?",
      component: Map,
      name: "Green Solo TD",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/mzi/:tab?",
      component: Map,
      name: "M.Z.I",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/dark-ages-zombie-incursion/:tab?",
      component: Map,
      name: "Dark Ages Zombie Incursion",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/vampirism-fire/:tab?",
      component: Map,
      name: "Vampirism Fire",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/battleships-crossfire/:tab?",
      component: Map,
      name: "Battleships Crossfire",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/warcraft-melee/:tab?",
      component: Map,
      name: "Warcraft Melee",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/trollforged/:tab?",
      component: Map,
      name: "Circle TD Trollforged",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/anime-carnage-reforged/:tab?",
      component: Map,
      name: "ACR",

      meta: {
        name: "Anime Carnage Reforged",
        activeTab: "maps",
      },
    },

    // {
    //   path: '/sheep-tag/leaderboard',
    //   component: () => import ('@/legacy/views/map/leaderboards/SheepTag'),
    //   name: 'Sheep Tag Leaderboard',
    //   meta: {
    //     activeTab: 'maps'
    //   }
    // },

    {
      path: "/sheep-tag/:tab?",
      component: Map,
      name: "Sheep Tag",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/mza/:tab?",
      component: Map,
      name: "MZA",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/direct-strike/:tab?",
      component: Map,
      name: "Direct Strike Reforged",
      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/tree-tag/:tab?",
      component: Map,
      name: "Tree Tag",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/ww3-diplomacy/:tab?",
      component: Map,
      name: "WW3 Diplomacy",

      meta: {
        name: "WW3 Diplomacy",
        activeTab: "maps",
      },
    },

    {
      path: "/naruto-wars/:tab?",
      component: Map,
      name: "Nwu",

      meta: {
        name: "Naruto Wars Unlimited",
        activeTab: "maps",
      },
    },

    {
      path: "/the-forest-of-fables/:tab?",
      component: Map,
      name: "The Forest Of Fables",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/anime-battle/:tab?",
      component: Map,
      name: "Anime Battle",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/helms-deep/:tab?",
      component: Map,
      name: "Helms Deep",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/warlock-brawl/:tab?",
      component: Map,
      name: "Warlock Brawl",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/line-tower-wars/:tab?",
      component: Map,
      name: "Line Tower Wars",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/war-of-the-kings/:tab?",
      component: Map,
      name: "War Of The Kings",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/path-wars/:tab?",
      component: Map,
      name: "Path Wars",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/footmen-apocalypse/:tab?",
      component: Map,
      name: "Footmen Apocalypse",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/wintermaul-wars/:tab?",
      component: Map,
      name: "Wintermaul Wars",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/fvg/:tab?",
      component: Map,
      name: "Footmen Vs Grunts",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/island-defense/:tab?",
      component: Map,
      name: "Island Defense",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/fight-of-anime-rve/:tab?",
      component: Map,
      name: "Fight of Anime RvE",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/horde-vs-alliance/:tab?",
      component: Map,
      name: "Horde vs Alliance",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/anime-choice-arena/:tab?",
      component: Map,
      name: "Anime Choice Arena",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/reforged-footmen-frenzy/:tab?",
      component: Map,
      name: "Reforged Footmen Frenzy",

      meta: {
        activeTab: "maps",
      },
    },

    {
      path: "/ffr",
      beforeEnter() {
        window.location = "/reforged-footmen-frenzy/leaderboard";
      },
    },
  ]),
});

export { delegate, navigate, redirect, resolve, router };

router.beforeEach((to, from, next) => {
  if (from.name === to.name) {
    setScroll();
  }

  next();
});
